// extracted by mini-css-extract-plugin
module.exports = {"Section9":"Section9_Section9__C8hrz","Layout1":"Section9_Layout1__A1mzD"};